(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('adminBaseTransitionHook', adminBaseTransitionHook);

    adminBaseTransitionHook.$inject = ['clubAdminStateName', 'associationAdminStateName', 'user', 'adminMode'];
    function adminBaseTransitionHook(clubAdminStateName, associationAdminStateName, user, adminMode) {
        return {
            onSuccess: [{}, hook]
        };

        function hook(transition) {
            var data = transition.$to().data,
                isAdminPage = data && data.requireAdmin,
                state, mode;

            if (isAdminPage) {
                for (; transition && !mode; transition = transition.redirectedFrom()) {
                    state = transition.targetState().state().name;
                    if (state == clubAdminStateName)
                        mode = adminMode.Club;
                    else if (state == associationAdminStateName)
                        mode = adminMode.Association;
                }
                if (mode)
                    user.adminMode = mode
            }
        }
    }
})();